import request from "@/utils/request";

// 路由
export function getRouters() {
  return request({
    url: "/system/user/getClientRouters",
    method: "get",
  });
}
